module.exports = __webpack_public_path__ + "img/9788989646112.aa9e604f.jpg";